const mediaQuery = globalThis.matchMedia('(max-width: 800px)');
const isMobileBreakpoint = mediaQuery.matches;

// Utility function to determine whether a given URL belongs to the current domain (local) or is external

// Usage ==> isLocalUrl(slide.URL);
export function isLocalUrl(urlToCheck) {
  return urlToCheck !== null && urlToCheck.includes(SITEBASEURL);
}
// ****************************************************************************************************************************************************
// Utility function to add target attribute to external links
// This can be used alongisde with isLocalUrl function

export function openNewTab(isLocal) {
  return isLocal ? '' : 'target="_blank"';
}

// ****************************************************************************************************************************************************
// Utility function to detect window size against a defined breakpoint size

// Usage ==> validateWindowSize(800);
export function validateWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(globalThis).width() >= breakpoint;
}

function getLinkType(url) {
  if (!url) return 'empty';
  if (isLocalUrl(url)) return 'local';
  return 'external';
}

function getAttributesString(urlToCheck, placeholder) {
  const type = getLinkType(urlToCheck);

  switch (type) {
    case 'empty':
      return placeholder
        ? `aria-label="${placeholder}" aria-disabled="true"`
        : `aria-disabled="true"`;

    case 'local':
      return placeholder ? `aria-label="${placeholder}"` : '';

    case 'external': {
      const label = placeholder ? `aria-label="${placeholder} (opens in a new tab)"` : '';
      return `target="_blank" rel="noopener noreferrer" ${label}`;
    }
  }
}

function setAttributesDOM($el, urlToCheck, placeholder) {
  const type = getLinkType(urlToCheck);

  switch (type) {
    case 'empty':
      $el.removeAttr('href').addClass('void-link');
      $el.attr('aria-disabled', 'true');
      if (placeholder) $el.attr('aria-label', placeholder);
      break;

    case 'local':
      if (placeholder) $el.attr('aria-label', placeholder);
      break;

    case 'external':
      $el.attr({ target: '_blank', rel: 'noopener noreferrer' });
      if (placeholder) $el.attr('aria-label', `${placeholder} (opens in a new tab)`);
      break;
  }
}

export function updateLinksAttributes(urlToCheck, placeholder, $el = null) {
  if ($el) {
    setAttributesDOM($el, urlToCheck, placeholder);
    return;
  }

  return getAttributesString(urlToCheck, placeholder);
}

export { isMobileBreakpoint };
